/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/* prettier-ignore-start */

/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */

// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: 2dMe7XWUq916KsPnra5vYj
// Component: 7jCYJVNv9q

import * as React from "react";

import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  Flex as Flex__,
  renderPlasmicSlot,
  StrictProps,
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";

import PermissionRule from "../../components/app-auth/PermissionRule"; // plasmic-import: OKf_hhc2Skl/component
import { _useStyleTokens } from "./PlasmicStyleTokensProvider"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/styleTokensProvider

import "@plasmicapp/react-web/lib/plasmic.css";

import "./plasmic_plasmic_kit_end_user_management.css"; // plasmic-import: 2dMe7XWUq916KsPnra5vYj/projectcss
import sty from "./PlasmicPermissionRuleGroup.module.css"; // plasmic-import: 7jCYJVNv9q/css

createPlasmicElementProxy;

export type PlasmicPermissionRuleGroup__VariantMembers = {};
export type PlasmicPermissionRuleGroup__VariantsArgs = {};
type VariantPropType = keyof PlasmicPermissionRuleGroup__VariantsArgs;
export const PlasmicPermissionRuleGroup__VariantProps =
  new Array<VariantPropType>();

export type PlasmicPermissionRuleGroup__ArgsType = {
  children?: React.ReactNode;
};
type ArgPropType = keyof PlasmicPermissionRuleGroup__ArgsType;
export const PlasmicPermissionRuleGroup__ArgProps = new Array<ArgPropType>(
  "children"
);

export type PlasmicPermissionRuleGroup__OverridesType = {
  root?: Flex__<"div">;
};

export interface DefaultPermissionRuleGroupProps {
  children?: React.ReactNode;
  className?: string;
}

const $$ = {};

function PlasmicPermissionRuleGroup__RenderFunc(props: {
  variants: PlasmicPermissionRuleGroup__VariantsArgs;
  args: PlasmicPermissionRuleGroup__ArgsType;
  overrides: PlasmicPermissionRuleGroup__OverridesType;
  forNode?: string;
}) {
  const { variants, overrides, forNode } = props;

  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );

  const $props = {
    ...args,
    ...variants,
  };

  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;

  const styleTokensClassNames = _useStyleTokens();

  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        "all",
        "root_reset_2dMe7XWUq916KsPnra5vYj",
        "plasmic_default_styles",
        "plasmic_mixins",
        styleTokensClassNames,
        sty.root
      )}
    >
      {renderPlasmicSlot({
        defaultContents: (
          <React.Fragment>
            <PermissionRule
              className={classNames("__wab_instance", sty.permissionRule__rr4E)}
              ruleName={"Anonymous visitors"}
            />

            <PermissionRule
              className={classNames(
                "__wab_instance",
                sty.permissionRule__lhnJ2
              )}
              isGroup={true}
              ruleName={"Logged in users"}
            />

            <PermissionRule
              className={classNames(
                "__wab_instance",
                sty.permissionRule__nvdAj
              )}
              hasMenu={true}
              isGroup={true}
              ruleName={"Logged in users"}
              withoutBorder={true}
            />
          </React.Fragment>
        ),
        value: args.children,
      })}
    </div>
  ) as React.ReactElement | null;
}

const PlasmicDescendants = {
  root: ["root"],
} as const;
type NodeNameType = keyof typeof PlasmicDescendants;
type DescendantsType<T extends NodeNameType> =
  (typeof PlasmicDescendants)[T][number];
type NodeDefaultElementType = {
  root: "div";
};

type ReservedPropsType = "variants" | "args" | "overrides";
type NodeOverridesType<T extends NodeNameType> = Pick<
  PlasmicPermissionRuleGroup__OverridesType,
  DescendantsType<T>
>;
type NodeComponentProps<T extends NodeNameType> =
  // Explicitly specify variants, args, and overrides as objects
  {
    variants?: PlasmicPermissionRuleGroup__VariantsArgs;
    args?: PlasmicPermissionRuleGroup__ArgsType;
    overrides?: NodeOverridesType<T>;
  } & // Specify variants directly as props
  Omit<PlasmicPermissionRuleGroup__VariantsArgs, ReservedPropsType> &
    // Specify args directly as props
    Omit<PlasmicPermissionRuleGroup__ArgsType, ReservedPropsType> &
    // Specify overrides for each element directly as props
    Omit<
      NodeOverridesType<T>,
      ReservedPropsType | VariantPropType | ArgPropType
    > &
    // Specify props for the root element
    Omit<
      Partial<React.ComponentProps<NodeDefaultElementType[T]>>,
      ReservedPropsType | VariantPropType | ArgPropType | DescendantsType<T>
    >;

function makeNodeComponent<NodeName extends NodeNameType>(nodeName: NodeName) {
  type PropsType = NodeComponentProps<NodeName> & { key?: React.Key };
  const func = function <T extends PropsType>(
    props: T & StrictProps<T, PropsType>
  ) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicPermissionRuleGroup__ArgProps,
          internalVariantPropNames: PlasmicPermissionRuleGroup__VariantProps,
        }),
      [props, nodeName]
    );
    return PlasmicPermissionRuleGroup__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName,
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicPermissionRuleGroup";
  } else {
    func.displayName = `PlasmicPermissionRuleGroup.${nodeName}`;
  }
  return func;
}

export const PlasmicPermissionRuleGroup = Object.assign(
  // Top-level PlasmicPermissionRuleGroup renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements

    // Metadata about props expected for PlasmicPermissionRuleGroup
    internalVariantProps: PlasmicPermissionRuleGroup__VariantProps,
    internalArgProps: PlasmicPermissionRuleGroup__ArgProps,
  }
);

export default PlasmicPermissionRuleGroup;
/* prettier-ignore-end */
